import { render, staticRenderFns } from "./demo-row-item.vue?vue&type=template&id=7d23dd4c&"
import script from "./demo-row-item.vue?vue&type=script&lang=js&"
export * from "./demo-row-item.vue?vue&type=script&lang=js&"
import style0 from "./demo-row-item.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports